"use client";

import { usePathname } from "next/navigation";

export default function ClientShell({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();
    const isAuthPage = pathname?.startsWith("/login") || pathname?.startsWith("/register") || pathname?.startsWith("/onboarding");

    return (
        <div className={`transition-all duration-300 ${isAuthPage ? "" : "md:pl-64"}`}>
            {children}
        </div>
    );
}
